import { api } from '@/lib/api/client';

export interface Suggestion {
  group: string;
  icon: string;
  label: string;
  sub: string;
  href: string;
}

export interface SearchResponse {
  query: string;
  results: Suggestion[];
  trending: string[];
}

export function search(q: string): Promise<SearchResponse> {
  return api.get<SearchResponse>(`/search?q=${encodeURIComponent(q)}`).then((r) => r.data);
}
